import { createBlueprint as r } from "@made-people/blueprint";
const o = r({
  slots: {
    wrapper: "flex gap-2 *:shrink-0 snap-mandatory scroll-px-[--spacing-x] px-[--spacing-x] -mx-[--spacing-x] snap-x overflow-x-scroll overflow-y-visible box-border"
  },
  variants: {}
});
export {
  o as scrollWrapperBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
